import {Pipe, PipeTransform} from '@angular/core';
import {DecimalPipe} from '@angular/common';

@Pipe({name: 'adaptedDecimal'})
export class AdaptedDecimalPipe implements PipeTransform {

  private decimalPipe: DecimalPipe;

  constructor() {
    this.decimalPipe = new DecimalPipe('de-DE');
  }

  transform(value: number, ...args: any[]): string {

    if (value < 10) {
      return this.decimalPipe.transform(value, '1.0-3');
    } else if (value < 100) {
      return this.decimalPipe.transform(value, '1.0-2');
    } else if (value < 1000) {
      return this.decimalPipe.transform(value, '1.0-1');
    }

    // value >= 1000
    return this.decimalPipe.transform(value, '1.0-0');

  }
}
